import IconUI from '../icon/IconUI';

export default function Button({
  buttonLabel,
  className = '',
  size = 'large',
  theme = 'primary',
  icon = 'chevronRight',
  onClick, // Add onClick prop
  disabled = false,
  ...rest
}) {
  const noLabelClass = !buttonLabel ? 'button--noLabel' : '';
  return (
    <button
      className={`button button--${theme} ${className} ${noLabelClass}`}
      title={buttonLabel}
      data-size={size}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      <div className="button-inner">
        {buttonLabel && (
          <div className="button-text">
            <span>{buttonLabel}</span>
          </div>
        )}

        {theme != 'toggle' && icon && (
          <>
            <IconUI icon={icon} />
            {theme !== 'tertiary' && <IconUI icon={icon} />}
          </>
        )}
      </div>
    </button>
  );
}
